export default __webpack_public_path__ + "static/media/onboardingAside.50f91b2d.jpg";